/**
 * Title-case a human name for display.
 * - Trims and collapses whitespace
 * - Capitalizes the first character of each space-separated word
 *
 * Examples:
 *  - "sandeep" -> "Sandeep"
 *  - "sandeep kumar" -> "Sandeep Kumar"
 */
export function toTitleCaseName(input) {
  if (typeof input !== "string") return "";

  const cleaned = input.trim().replace(/\s+/g, " ");
  if (!cleaned) return "";

  return cleaned
    .split(" ")
    .map((part) =>
      part.length > 0 ? `${part.charAt(0).toUpperCase()}${part.slice(1)}` : part
    )
    .join(" ");
}

